import { useMutation } from '@tanstack/react-query';

import { deleteServiceFee } from '~/services/BusinessTraveller/BusinessTravellerService';

export function useDeleteServiceFee() {
  return useMutation({
    mutationFn: ({ businessId, serviceFeeId }: { businessId: string; serviceFeeId: string }) =>
      deleteServiceFee(businessId, serviceFeeId),
  });
}
